import { create } from "zustand";

import { BalanceResponse, subscriptionApi } from "../api/subscription.api";

interface BalanceState {
  balance: BalanceResponse | null;
  loading: boolean;
  error: string | null;

  // Actions
  fetchBalance: () => Promise<void>;
  setBalance: (balance: BalanceResponse) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  reset: () => void;
}

export const useBalanceStore = create<BalanceState>(set => ({
  balance: null,
  loading: false,
  error: null,

  fetchBalance: async (): Promise<void> => {
    try {
      // Не обнуляем balance при повторной загрузке, только устанавливаем loading
      set({ loading: true, error: null });
      const data = await subscriptionApi.getBalance();
      set({ balance: data, loading: false });
    } catch (err) {
      // Игнорируем 401 ошибки - это нормально для неавторизованных пользователей
      const isUnauthorized =
        err && typeof err === "object" && "response" in err && (err as any).response?.status === 401;

      if (!isUnauthorized) {
        const errorMessage = err instanceof Error ? err.message : "Ошибка загрузки баланса";
        console.error("Error fetching balance:", err);
        set({ error: errorMessage, loading: false });
      } else {
        set({ loading: false });
      }
    }
  },

  setBalance: (balance: BalanceResponse): void => {
    set({ balance, loading: false, error: null });
  },

  setLoading: (loading: boolean): void => {
    set({ loading });
  },

  setError: (error: string | null): void => {
    set({ error });
  },

  reset: (): void => {
    set({ balance: null, loading: false, error: null });
  }
}));

// Загружаем баланс при инициализации store (если пользователь авторизован)
// Это будет вызвано при первом использовании store
// WebSocket подключение теперь управляется через useBalanceWebSocket хук
if (typeof window !== "undefined") {
  // Небольшая задержка, чтобы auth успел инициализироваться
  setTimeout(() => {
    useBalanceStore.getState().fetchBalance();
  }, 100);
}
